import React from 'react';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import { Navigate } from 'react-router';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';

export default class TimeSheetReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: null,
            records: [],
            fromDate: null,
            toDate: null,
            users: [],
            selectedUserIds: []
        };
    }

    componentDidMount() {
        this.httpPost('api/v1/user/list', { page: 1, count: 200, phrase: '', filters: {} })
            .then(data => {
                if (data.status === 1) this.setState({ users: data.records || [], data: data, loading: false });
            })
            .catch(() => { });
    }

    toISODate(dateObj) {
        if (!dateObj) return null;
        return dateObj.toDate().toISOString();
    }

    loadReport = () => {
        this.setState({ loading: true });
        this.httpPost('api/v1/report/timesheet', {
            fromDate: this.toISODate(this.state.fromDate),
            toDate: this.toISODate(this.state.toDate),
            userIds: this.state.selectedUserIds.length > 0 ? this.state.selectedUserIds : null
        }).then(data => {
            if (data.status === 1) {
                this.setState({ records: data.records, loading: false, data });
            } else {
                this.showErorrMessage(data.message);
                this.setState({ loading: false });
            }
        });
    };

    toggleUser(userId) {
        const arr = [...this.state.selectedUserIds];
        const idx = arr.indexOf(userId);
        if (idx > -1) arr.splice(idx, 1);
        else arr.push(userId);
        this.setState({ selectedUserIds: arr });
    }

    // ========== توابع کمکی برای محاسبه مجموع ساعت ==========
    parseToMinutes(hoursWorked) {
        if (!hoursWorked) return 0;
        if (typeof hoursWorked === 'number') return Math.round(hoursWorked * 60);
        const hoursMatch = hoursWorked.match(/(\d+)\s*ساعت/);
        const minsMatch = hoursWorked.match(/(\d+)\s*دقیقه/);
        const hours = hoursMatch ? parseInt(hoursMatch[1], 10) : 0;
        const mins = minsMatch ? parseInt(minsMatch[1], 10) : 0;
        return (hours * 60) + mins;
    }

    formatMinutes(totalMinutes) {
        if (!totalMinutes || totalMinutes <= 0) return '۰ دقیقه';
        const h = Math.floor(totalMinutes / 60);
        const m = totalMinutes % 60;
        let result = '';
        if (h > 0) result += `${h} ساعت`;
        if (m > 0) result += (h > 0 ? ' و ' : '') + `${m} دقیقه`;
        return result;
    }

    calculateSummary(records) {
        const summary = {};
        records.forEach(r => {
            const name = r.fullName || 'نامشخص';
            const mins = this.parseToMinutes(r.hoursWorked);
            summary[name] = (summary[name] || 0) + mins;
        });
        const totalMinutes = Object.values(summary).reduce((sum, m) => sum + m, 0);
        return { summary, totalMinutes };
    }

    // ========== خروجی Excel ==========
    exportExcel = () => {
        const { records } = this.state;
        if (!records.length) {
            this.showErorrMessage('داده‌ای برای خروجی وجود ندارد');
            return;
        }

        let html = `<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40">
<head><meta charset="UTF-8"><title>تایم‌شیت</title></head><body>`;
        html += `<table border="1">
            <tr>
                <th>ردیف</th><th>کاربر</th><th>تاریخ</th><th>روز هفته</th><th>ورود</th><th>خروج</th><th>ساعت کارکرد</th>
            </tr>`;
        records.forEach((r, idx) => {
            html += `<tr>
                <td>${idx + 1}</td>
                <td>${r.fullName}</td>
                <td>${r.datePersian}</td>
                <td>${r.dayOfWeekPersian}</td>
                <td>${r.clockInTime || '---'}</td>
                <td>${r.clockOutTime || '---'}</td>
                <td>${r.hoursWorked}</td>
            </tr>`;
        });
        html += `</table></body></html>`;

        const blob = new Blob(['\ufeff' + html], { type: 'application/vnd.ms-excel;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'timesheet.xls';
        link.click();
        URL.revokeObjectURL(link.href);
    };

    // ========== چاپ ==========
    printReport = () => {
        const { records, fromDate, toDate } = this.state;
        const { summary, totalMinutes } = this.calculateSummary(records);

        let html = `<html><head><title>تایم‌شیت کارمندان</title>
            <style>
                body { font-family: Tahoma, sans-serif; direction: rtl; padding: 20px; font-size: 9pt; }
                table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                th, td { border: 1px solid #000; padding: 5px 8px; text-align: center; }
                th { background: #eee; }
                h2 { text-align: center; }
                .summary-table { width: 60%; margin: 20px auto 0 auto; }
            </style></head><body>
            <h2>تایم‌شیت کارمندان</h2>
            <p>بازه: ${fromDate?.format?.('jYYYY/jMM/jDD') || '---'} تا ${toDate?.format?.('jYYYY/jMM/jDD') || '---'}</p>
            <table>
                <tr><th>ردیف</th><th>کاربر</th><th>تاریخ</th><th>روز هفته</th><th>ورود</th><th>خروج</th><th>ساعت کارکرد</th></tr>`;
        records.forEach((r, idx) => {
            html += `<tr>
                <td>${idx + 1}</td>
                <td>${r.fullName}</td>
                <td>${r.datePersian}</td>
                <td>${r.dayOfWeekPersian}</td>
                <td>${r.clockInTime || '---'}</td>
                <td>${r.clockOutTime || '---'}</td>
                <td>${r.hoursWorked}</td>
            </tr>`;
        });
        html += `</table>`;

        // جدول جمع‌بندی
        html += `<table class="summary-table">
            <tr><th>کاربر</th><th>مجموع ساعت کارکرد</th></tr>`;
        Object.entries(summary).forEach(([name, mins]) => {
            html += `<tr><td>${name}</td><td>${this.formatMinutes(mins)}</td></tr>`;
        });
        html += `<tr><td><strong>جمع کل</strong></td><td><strong>${this.formatMinutes(totalMinutes)}</strong></td></tr>`;
        html += `</table>`;

        html += `</body></html>`;
        const win = window.open('', '_blank');
        win.document.write(html);
        win.document.close();
        setTimeout(() => win.print(), 300);
    };

    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />;
        const { loading, records, fromDate, toDate, users, selectedUserIds } = this.state;
        const { summary, totalMinutes } = records.length ? this.calculateSummary(records) : { summary: {}, totalMinutes: 0 };

        let contents = this.state.loading ? this.renderLoading() : [
            this.state.lockScreen === 1 && this.lockScreen(),
            <Header data={this.state.data} />,
            <div className="nk-content" key="content">
                <div className="container-fluid">
                    <div className="nk-content-inner">
                        <div className="nk-content-body">
                            <div className="nk-block-head nk-block-head-sm">
                                <div className="nk-block-between">
                                    <div className="nk-block-head-content">
                                        <h3 className="page-title">تایم‌شیت کارمندان</h3>
                                    </div>
                                    {records.length > 0 && (
                                        <div className="nk-block-head-content d-flex">
                                            <button className="btn btn-outline-info" onClick={this.printReport}>
                                                <em className="icon ni ni-printer"></em> چاپ گزارش
                                            </button>
                                            <button className="btn btn-outline-success" onClick={this.exportExcel}>
                                                <em className="icon ni ni-file-xls"></em> خروجی Excel
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* فیلترها */}
                            <div className="card card-bordered mb-3">
                                <div className="card-inner">
                                    <div className="row g-3 align-items-end">
                                        <div className="col-md-2">
                                            <label className="form-label">از تاریخ</label>
                                            <DatePicker calendar={persian} locale={persian_fa}
                                                value={fromDate} onChange={d => this.setState({ fromDate: d })}
                                                format="YYYY/MM/DD" inputClass="form-control" />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label">تا تاریخ</label>
                                            <DatePicker calendar={persian} locale={persian_fa}
                                                value={toDate} onChange={d => this.setState({ toDate: d })}
                                                format="YYYY/MM/DD" inputClass="form-control" />
                                        </div>
                                        <div className="col-md-4">
                                            <label className="form-label">کاربران (اختیاری)</label>
                                            <div style={{ maxHeight: '100px', overflowY: 'auto', border: '1px solid #ddd', borderRadius: 6, padding: 6 }}>
                                                {users.map(u => (
                                                    <label key={u.id} style={{ marginLeft: 12 }}>
                                                        <input type="checkbox" checked={selectedUserIds.includes(u.id)} onChange={() => this.toggleUser(u.id)} />
                                                        {' '}{u.fullName}
                                                    </label>
                                                ))}
                                            </div>
                                        </div>
                                        <div className="col-md-2">
                                            <button className="btn btn-primary" onClick={this.loadReport}
                                                disabled={!fromDate || !toDate}>دریافت گزارش</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* جدول اصلی */}
                            <div className="card card-bordered card-stretch">
                                {loading ? this.renderLoading() : (
                                    records.length > 0 ? (
                                        <div className="card-inner p-0">
                                            <table className="table table-bordered table-responsive">
                                                <thead>
                                                    <tr>
                                                        <th>ردیف</th>
                                                        <th>کاربر</th>
                                                        <th>تاریخ</th>
                                                        <th>روز هفته</th>
                                                        <th>ورود</th>
                                                        <th>خروج</th>
                                                        <th>ساعت کارکرد</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {records.map((r, idx) => (
                                                        <tr key={`${r.userId}_${r.datePersian}`}>
                                                            <td>{idx + 1}</td>
                                                            <td>{r.fullName}</td>
                                                            <td>{r.datePersian}</td>
                                                            <td>{r.dayOfWeekPersian}</td>
                                                            <td>{r.clockInTime || '---'}</td>
                                                            <td>{r.clockOutTime || '---'}</td>
                                                            <td>{r.hoursWorked}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>

                                            {/* جمع‌بندی پایین صفحه */}
                                            <div className="p-3" style={{ borderTop: '2px solid #e2e8f0', background: 'rgba(255,255,255,0.04)' }}>
                                                <h5 className="mb-3">جمع ساعت کارکرد به تفکیک کاربر</h5>
                                                <table className="table table-bordered" style={{ maxWidth: '500px' }}>
                                                    <thead>
                                                        <tr>
                                                            <th>کاربر</th>
                                                            <th>مجموع ساعت کارکرد</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {Object.entries(summary).map(([name, mins]) => (
                                                            <tr key={name}>
                                                                <td>{name}</td>
                                                                <td>{this.formatMinutes(mins)}</td>
                                                            </tr>
                                                        ))}
                                                        <tr style={{ fontWeight: 'bold', background: 'rgba(0,0,0,0.03)' }}>
                                                            <td>جمع کل</td>
                                                            <td>{this.formatMinutes(totalMinutes)}</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="card-inner"><div className="alert alert-info">داده‌ای یافت نشد.</div></div>
                                    )
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>,
            <Footer key="footer" />
        ];

        return contents;
    }
}